﻿export interface IEmailSendeeDeleteRequestContract {
    emailTemplateId: number;
    emailSendeeId: number;
}
